export default __webpack_public_path__ + "static/media/photo--lg--rene-2.ea7c6408.jpg";